
export class VenueDetailsModel {
  public id: number;
  public groupId: number;
  public name: string;
  public address: string;
  public phoneNumber: string;
  public bookingUrl: string;
  public bookingEmail: string;
  public bookingOption: boolean;
  public location: VenueDetailsCoordinates;
  public subAreaId: number;
  public locationFilter: string;
  public specificLocation: string;
  public note: string;
  public dateAdded: Date;
  public subsidieries: VenueDetailsSubsidiaryData[];
  public contacts: VenueDetailsContact[];
  public offers: VenueDetailsOffer[];
  public venueImages: VenueDetailsImage[];
  public visits: VenueDetailsVisit[];
  public notifications: VenueDetailsNotifications[];
  public orderListBar: VenuePositionListModel;
  public orderListRestaurant: VenuePositionListModel;
  public utcOffset: number;
  public perkImages: VenueDetailsImage[];
  public perkDescription: string
  public isBulkNotifications: boolean;



  constructor() {
    this.id = 0;
    this.subsidieries = new Array();
    this.contacts = new Array();
    // this.offers = new Array();
    this.venueImages = new Array();
    this.visits = new Array();
    this.location = new VenueDetailsCoordinates();
    this.location.latitude = 51.5074; // London coordinates
    this.location.longitude = 0.1278;
  }
}
export class VenueDetailsImage {
  public url: string;
  public imageId: number;
  public venueType: string;
  public data: File;
  public order: number;
  public fileIndex: number;
  public mimeType: string;
  public isPerkImage: boolean;
}

export class VenueDetailsCoordinates {
  public latitude: number;
  public longitude: number;
}
export class VenueDetailsNotifications {
  public text: string;
}
export class VenueDetailsSubsidiaryData {
  public type = '';
  public name = '';
  public venueCategory = '';
  public status = '';
  public price = 0;
  public ratePerCover = 2;
  public menuPageUrl = '';
  public description = '';
  public durationAlive = 0;
  public order = 1;
  public exclusions = '';
  public cuisines = new Array();
  public updated = false;
  public cuisinesString = '';
  public vibes = new Array();
  public vibesString = '';
}
export class VenueDetailsContact {
  public id = 0;
  public contactName: '';
  public contactEmail: '';
  public contactOfficePhone: '';
  public contactMobilePhone: '';
  public position: '';
  public new = false;
  public updated = false;
}
export class VenueDetailsOffer {
  static days: string[];

  public type: string;
  public day: string;
  public offerRate = 0;
  public pendingOfferRate: number;
  public pendingOfferRateTime: Date;
  public pendingTotalBillTime: Date;
  public pendingTotalBill: boolean;
  public pendingLunchTime: Date;
  public pendingLunch: boolean;
  public pendingDinnerTime: Date;
  public pendingDinner: boolean;
  public pendingBeforeNineTime: Date;
  public pendingBeforeNine: boolean;
  public pendingAfterNineTime: Date;
  public pendingAfterNine: boolean;
  public pendingIsLive: boolean;
  public pendingIsLiveTime: Date;
  public pendingMaxPartySizeTime: Date;
  public pendingMaxPartySize: number;
  public totalBill = true;
  public lunch = true;
  public dinner = true;
  public beforeNine = true;
  public afterNine: boolean;
  public maxPartySize: number;
  public bookingRequired: boolean;
  public isLive: boolean;
  public exclusions: string;
  public updated = false;

  public offerTypeDirty: boolean;
  public maxPartySizeDirty: boolean;

  public isLiveDirty: boolean;
  public showInitialIsLive: boolean;
  public showInitialPerk: boolean;
  public showPendingFalseIsLive: boolean;
  public showPendingTrueIsLive: boolean;
  public displayIsLive: boolean;
  public isLiveLabel: string;

  public lunchDirty: boolean;
  public showInitialLunch: boolean;
  public showPendingFalseLunch: boolean;
  public showPendingTrueLunch: boolean;
  public displayLunch: boolean;
  public lunchLabel: string;

  public dinnerDirty: boolean;
  public showInitialDinner: boolean;
  public showPendingFalseDinner: boolean;
  public showPendingTrueDinner: boolean;
  public displayDinner: boolean;
  public dinnerLabel: string;

  public afterNineDirty: boolean;
  public showInitialAfterNine: boolean;
  public showPendingFalseAfterNine: boolean;
  public showPendingTrueAfterNine: boolean;
  public displayAfterNine: boolean;
  public afterNineLabel: string;

  public beforeNineDirty: boolean;
  public showInitialBeforeNine: boolean;
  public showPendingFalseBeforeNine: boolean;
  public showPendingTrueBeforeNine: boolean;
  public displayBeforeNine: boolean;
  public beforeNineLabel: string;

  public offerRateLabel: string;

  public sliderOfferRate: number;
  public sliderPendingOfferRate: number;
  public perkImage: VenueDetailsImage;
  public perkDescription: string;
  public perk: boolean;
  public pendingPerk: boolean;
  public pendingPerkTime: Date;
  public showPendingFalsePerk: boolean;
  public showPendingTruePerk: boolean;
  public perkDirty: boolean;
  public perkLabel: string;
  public displayPerk: boolean;

  static GetNewOffers(type): VenueDetailsOffer[] {
    if (!VenueDetailsOffer.days) {
      VenueDetailsOffer.days = new Array();
      VenueDetailsOffer.days.push('Monday');
      VenueDetailsOffer.days.push('Tuesday');
      VenueDetailsOffer.days.push('Wednesday');
      VenueDetailsOffer.days.push('Thursday');
      VenueDetailsOffer.days.push('Friday');
      VenueDetailsOffer.days.push('Saturday');
      VenueDetailsOffer.days.push('Sunday');
    }
    const result = new Array();
    for (const day of VenueDetailsOffer.days) {
      const offer = new VenueDetailsOffer();
      offer.type = type;
      offer.day = day;
      offer.offerRate = 25;
      offer.totalBill = false;
      offer.lunch = false;
      offer.dinner = false;
      offer.beforeNine = false;
      offer.afterNine = false;
      offer.maxPartySize = 2;
      offer.bookingRequired = false;
      if (offer.day === 'Monday' || offer.day === 'Tuesday' || offer.day === 'Wednesday' || offer.day === 'Thursday') {
        offer.isLive = true;
      } else {
        offer.isLive = false;
      }
      offer.exclusions = '';
      offer.updated = false;

      offer.pendingOfferRate = null;
      offer.pendingOfferRateTime = null;
      offer.pendingTotalBillTime = null;
      offer.pendingTotalBill = null;
      offer.pendingLunchTime = null;
      offer.pendingLunch = null;
      offer.pendingDinnerTime = null;
      offer.pendingDinner = null;
      offer.pendingBeforeNineTime = null;
      offer.pendingBeforeNine = null;
      offer.pendingAfterNineTime = null;
      offer.pendingAfterNine = null;
      offer.pendingIsLive = null;
      offer.pendingIsLiveTime = null;
      offer.pendingMaxPartySizeTime = null;
      offer.pendingMaxPartySize = null;

      if (day === 'Friday' || day === 'Saturday' || day === 'Sunday') { // to be added
      }
      result.push(offer);
    }
    return result;
  }
}

export class VenueDetailsVisit {
  public id: number;
  public venueId: number;
  public type: string;
  public memberId: number;
  public memberName: string;
  public timeOfVisit: Date;
  public partySize: number;
  public revenue: number;
  public membershipNumber: string;
  public editable: boolean;
  public oldPartySize: number;
  public newPartySize: number;
  public editMode = false;
  public ratePerCover: number;
  public isPerkUsed: boolean;
}

export class GroupVenueListResponseModel {
  public id: number;
  public name: string;
  public venues: VenueNamesListItem[];
}
export class VenueNamesListItem {
  public id: number;
  public name: string;
}

export class VenuePositionListModel {
  public venues: VenuePositionListItemModel[];
}
export class VenuePositionListItemModel {
  public id: number;
  public order: number;
  public name: string;
}

export class SelectListItem {
  public id: number;
  public name: string;
  public selected: boolean;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/venue-details.model.ts